import { render, staticRenderFns } from "./AllocationExpert.vue?vue&type=template&id=19e67966&scoped=true&"
import script from "./AllocationExpert.vue?vue&type=script&lang=js&"
export * from "./AllocationExpert.vue?vue&type=script&lang=js&"
import style0 from "./AllocationExpert.vue?vue&type=style&index=0&id=19e67966&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e67966",
  null
  
)

export default component.exports